// extracted by mini-css-extract-plugin
module.exports = {"panel":"Logo_panel__1BG6C","tilt":"Logo_tilt__HJJDQ"};